var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterFaded(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 64,
    viewBox: "0 0 63 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.9754 13.3678C59.7866 14.3377 57.4353 14.993 54.9634 15.2892C57.5139 13.7631 59.4221 11.3611 60.3318 8.5315C57.9355 9.95484 55.3129 10.9567 52.578 11.4936C50.7389 9.52986 48.3028 8.22829 45.6482 7.79092C42.9935 7.35355 40.2687 7.80486 37.8967 9.07477C35.5248 10.3447 33.6385 12.3622 32.5307 14.814C31.4229 17.2658 31.1555 20.0148 31.7701 22.6341C26.9147 22.3903 22.1647 21.1283 17.8286 18.9299C13.4924 16.7316 9.66695 13.6461 6.60045 9.87361C5.55193 11.6823 4.94903 13.7793 4.94903 16.0127C4.94786 18.0232 5.44297 20.0029 6.39043 21.7762C7.33788 23.5495 8.70839 25.0615 10.3804 26.1781C8.44132 26.1164 6.54507 25.5924 4.84942 24.6499V24.8071C4.84923 27.627 5.82463 30.36 7.61013 32.5426C9.39563 34.7251 11.8812 36.2227 14.6452 36.7812C12.8464 37.268 10.9606 37.3397 9.13 36.9909C9.90983 39.4172 11.4289 41.5389 13.4745 43.059C15.52 44.5791 17.9898 45.4215 20.5379 45.4682C16.2123 48.8639 10.8702 50.7058 5.37106 50.6977C4.39694 50.698 3.42364 50.6411 2.45618 50.5273C8.03817 54.1163 14.536 56.0211 21.1722 56.0137C43.6368 56.0137 55.9175 37.4077 55.9175 21.271C55.9175 20.7467 55.9044 20.2172 55.8808 19.693C58.2696 17.9655 60.3316 15.8263 61.9701 13.3757L61.9754 13.3678Z",
    fill: "black",
    fillOpacity: 0.3
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterFaded);
export default __webpack_public_path__ + "static/media/twitter-faded.5ef274727cca61b42350f91079fde747.svg";
export { ForwardRef as ReactComponent };